import React from "react";
import { Alert } from "@mui/material";
import { TipoMaterialN1 } from "../types/materiaisN1.types";
import { useTravaPlanilhaN1 } from "../hooks/useTravaPlanilhaN1";

interface AvisoPlanilhaPendenteN1Props {
  tipoMaterial: TipoMaterialN1;
}

/**
 * Plano 14/10/2026 (Frente 4): com planilha do tipo em andamento a tela de cadastro fica
 * somente-leitura (useSomenteLeituraN1) — este aviso diz o porquê e como liberar.
 */
export const AvisoPlanilhaPendenteN1: React.FC<AvisoPlanilhaPendenteN1Props> = ({ tipoMaterial }) => {
  const { trava } = useTravaPlanilhaN1(tipoMaterial);
  if (!trava?.planilhaPendente) return null;

  return (
    <Alert severity="warning" sx={{ mb: 2, fontSize: "0.85rem" }}>
      {trava.mensagemPlanilhaPendente}
    </Alert>
  );
};
